import { ISafariObjectState } from '@safarilaw-webapp/shared/redux';
import { SquirrelValue } from '../squirrel-value/models/app/squirrel-value';
import { createFeatureSelector } from '@ngrx/store';

export const FEATURE_STATE = 'data-access-squirrel';
export const getSharedFeatureState = createFeatureSelector<ISquirrelState>(FEATURE_STATE);

export const PROJECT_NAME = 'squirrel';

export interface ISquirrelState {
  squirrelCombinedState: {
    squirrelState: ISafariObjectState<SquirrelValue>;
  };
}
